// @flow
import { TreatmentDetails } from '@screens';

// export const config = { amp: true };

export default TreatmentDetails;
